import React from "react";

const STATUS_LABELS = {
  active: "Ativo",
  inactive: "Inativo",
  pending: "Pendente",
  rejected: "Rejeitado",
  validating: "Em validação",
  completed: "Concluído",
};

export const resolveStatusLabel = (value, options = []) => {
  const option = options.find(
    (item) => String(item?.value) === String(value)
  );

  if (option?.label) return option.label;
  if (value === null || value === undefined || String(value).trim() === "") {
    return "Não informado";
  }

  const normalized = String(value).trim();
  const translated = STATUS_LABELS[normalized.toLowerCase()];
  if (translated) return translated;

  // Unknown numeric codes are implementation details and should not leak into
  // the interface. Text statuses, however, remain useful to the operator.
  if (/^\d+$/.test(normalized)) return "Não informado";

  return normalized
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .replace(/^./, (character) => character.toUpperCase());
};

const StatusBadge = ({ value, options = [], className = "", style }) => {
  const label = resolveStatusLabel(value, options);
  const normalizedStatus =
    value === null || value === undefined || String(value).trim() === ""
      ? "unknown"
      : String(value).trim().toLowerCase();

  return (
    <span
      className={`xv-status-badge ${className}`.trim()}
      data-status={normalizedStatus}
      title={label}
      style={style}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
